//
// DataStyleGroup.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../GTLModel";

var DataStyleGroup = createModule("gtl::DataStyleGroup", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        name: 7,
        dataFields: [7],
    },
    ,
    ,
    {
        containsDataField: [2,7],
        containsRole: [2,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default DataStyleGroup;
